import { Box, Card, IconButton, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { dummy } from "../assets/assets";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import styled from "styled-components";

interface IProps {
  descriptionHeight?: string;
  title: string;
  description: string;
  link?: string;
  linkTitle?: string;
  icon?: string;
  color?: string;
}

const StyledAnchorTag = styled(Link)(({ theme }) => ({
  position: "relative",
  display: "inline-block",
  textDecoration: "none",
  color: "#18272F",
  fontWeight: 700,
  verticalAlign: "top",
  width: "100%",
  padding: "10px 0",

  ".second": {
    // transformOrigin: '100% 50%',
    transform: "translate3d(1000%, 0, 0)",
    transition: "all 0.5s ease",
    position: "absolute",
    left: 0,
    top: 0,
  },

  ".first": {
    display: "inline-block",
    transition: "all 0.5s ease",
    transform: "translate3d(0, 0, 0) rotate(-90deg)",
    padding: 0,
    position: "absolute",
    left: 0,
    top: 0,
    color: "#0B2B4C",
  },

  // "&:hover .first": {
  //   transform: 'translate3d(-200%, 0, 0)',

  // },

  // "&:hover .second": {
  //   transform: 'translate3d(-0%, 0, 0)',
  //   left: 0,
  // }
}));

const StyledMuiCard = styled(Card)(({ theme }) => ({
  padding: "20px 20px",
  backgroundColor: "#fff",
  boxShadow: "0px 8px 16px 0px rgba(205, 190, 255, 0.2) !important",
  cursor: "pointer",
  background: "linear-gradient(to right, #fff 50%, #0B2B4C 50%) !important",
  backgroundSize: "200% 100% !important",
  backgroundPosition: "left bottom !important",
  transition: "background-position 0.5s ease !important",
  color: "#333",
  ".img-container": {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    overflow: "hidden",
    backgroundColor: "#fff",
    padding: "4px",
    display: "flex",
    placeContent: "center",
    alignItems: "center",
    img: {
      width: "30px",
      height: "30px",
    },
  },
  "&:hover": {
    backgroundPosition: " right bottom !important",
    ".card-title": {
      color: "#fff !important",
    },
    ".first": {
      color: "#fff",
    },
  },
}));

const CustomCard = (props: IProps) => {
  const {
    description,
    link = "#",
    title,
    descriptionHeight = "auto",
    linkTitle,
    icon = dummy,
  } = props;
  return (
    <StyledMuiCard>
      <Stack spacing={2}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginBottom: "10px !important",
          }}
        >
          <Box className="img-container" mr={1} sx={{}}>
            <img src={icon} alt={title} />
          </Box>
          <Typography
            className="card-title"
            variant="h4"
            sx={{
              fontSize: "22px",
              fontWeight: 700,
              position: "relative",
              ":after": {
                content: '""',
                position: "absolute",
                bottom: "-17px",
                left: "0px",
                width: "70%",
                backgroundColor: "#e2e0ff",
                transition: "all 0.4s ease-in-out 0s",
                height: "3px",
              },
            }}
          >
            {title}
          </Typography>
        </Box>
        <Box sx={{ height: descriptionHeight, overflow: "hidden" }}>
          <Typography
            className="card-text"
            sx={{
              color: "#7a8595",
              fontSize: "15px",
              // lineHeight: "30px",
              fontWeight: 500,
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginBottom: 0,
              letterSpacing: 1,
            }}
          >
            {description}
          </Typography>
        </Box>
        {linkTitle && (
          <StyledAnchorTag to={link} id="style-2" data-replace="Read more">
            <IconButton
              className="first"
              color="primary"
              aria-label="add to shopping cart"
            >
              <ExpandCircleDownIcon />
            </IconButton>
            <span className="second">Read more</span>
          </StyledAnchorTag>
        )}
      </Stack>
    </StyledMuiCard>
  );
};

export default CustomCard;
